export default "__VITE_ASSET__CxVqaU4g__"